import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class WavyTile extends Floor {
	static key = "WavyTile";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): WavyTile {
		const f = new WavyTile(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
